import React from "react";
const Divider: React.FC = ()=> {
    return (
        <div className="container">
            <div className="mil-divider" />
        </div>
    );
};

export default Divider;